import { useLazyQuery } from '@apollo/client/react';

import { LIST_GROUPS } from '../queries/ListGroups';
import { GroupConnection } from '../types/GroupTypes';
import { UseHookOptions } from '../types/UseHookOptions';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

export interface ListGroupsProps {
  name?: string;
  case_id?: string;
  limit?: number;
}

export function useListGroups(options: UseHookOptions = {}) {
  const context: LoggerContextProps = {
    action: 'listGroups',
  };
  const { useCache = true } = options;
  const [listGroupsQuery, { data, loading, error, refetch }] = useLazyQuery<{
    listGroups: GroupConnection[];
  }>(LIST_GROUPS, {
    fetchPolicy: useCache ? 'cache-first' : 'network-only',
  });

  const listGroups = async (filter: ListGroupsProps[], limit = 100) => {
    try {
      await listGroupsQuery({
        variables: {
          filter,
          limit,
        },
      });
    } catch (error) {
      handleError(error, context, `Failed to list groups.`);
    }
  };

  return { listGroups, refetch, data, loading, error };
}
